var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['sys-radio__container', _vm.disabled && '--disabled', _vm.size && ("normal-" + _vm.size)]},[_c('div',{class:[
            'sys-radio',
            {
                checked: _vm.value
            }
        ],on:{"click":function($event){!_vm.disabled && _vm.$emit('input', !_vm.value)}}},[_c('span',{staticClass:"sys-radio__icon"})]),(_vm.label)?_c('label',{staticClass:"sys-radio__label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }